/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import { updateOffice } from '../../slice/OfficeSlice'


const basePath = '/office-options'

const OfficeOptionsEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchOfficeOptions: builder.query<any, any>({
    query: () => `${basePath}`,
    providesTags: ['office-options']
  }),

  createOfficeOption: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['office-options']
  }),

  deleteOfficeOption: builder.mutation<any, any>({
    query: (id) => ({
      url: `${basePath}?id=${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['office-options'],
  }),

  updateOfficeOption: builder.mutation<any, any>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'put',
      body,
    }),
    invalidatesTags: ['office-options'],
  }),

})

export default OfficeOptionsEndpoints
